import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { BehaviorSubject, Observable } from "rxjs";
import { H_CHECK, PAGE_SIZE, R_CHECK, environment } from "../../environments/environment"
import { ApiService } from "./api.service";
import { SearchResult } from "../models/search-result.model";
import { ClientSearchModel, ClientSearchResultsModel, TypeClientSearch } from "../models/search-client.model";
import { ClientModel } from "../models/client.model";
import { RecallModel } from "../models/recall.model";
import { ClientFamilyModel } from "../models/client-family.model";
import { ClientContactModel } from "../models/client-contact.model";
import { ApptModel } from "../models/appt.model";
import { CashRegModel } from "../models/cash-reg.model";
import { ProcListModel } from "../models/proc-list.model";
import { ResponseModel } from "../models/response.model";
import { BriefHistoryCategoryModel } from "../models/brief-history-category.model";
import { PetTotalTransactionModel } from "../models/pet-totaltransaction.model";
import { CurrentUserModel } from "../models/current-user.model";
import { ApptDetailModel } from "../models/appt-detail.model";
import { HospitalizedPatientDetailsModel } from "../models/hospitalized-patient-details.model";
import { HospitalizedPatientDetailsNProcModel } from "../models/hospitalized-patient-details-nproc.model";
import { IncLabResultsListModel } from "../models/inc-lab-results-list.model";
import { IncLabResultsListSingleModel } from "../models/inc-lab-results-list.model";
import { ClientInfoRecallModel } from "../models/client-info-recall.model";
import { ClinicDetailsModel } from "../models/clinic-details.model";
import { ClinicModel } from "../models/clinic.model";
import { AnnualRecallPhonelist } from "../models/annual-recall-phonelist.model";
import { EmailServiceModel } from "../models/email-service.model";
import { MessagesModel,DistinctContactsModel } from "../models/messages.model";
import { ClientEmail } from "../models/client-email.model";  
import { ClientNoteModel } from "../models/client-note.model";  
import { ClientNoteTypeModel } from "../models/client-note.model";  
import { PersonModel } from "../models/person.model";  
import { SignatureModel } from "../models/signature.model";  
import { ClientFilesModel } from "../models/client-files.model";
import { ManagerialService } from '../services/managerial.service';  
import { encode_base64, encode_utf8 } from '../../environments/environment';
import { Subject } from 'rxjs';
declare var $: any;

@Injectable({
    providedIn: "root"
})
export class ClientService {

    private baseUrl: string = 'client';
    private baseUrl2: string = 'user';
    current_client_no: number = 0;
    selected_client: ClientSearchResultsModel = new ClientSearchResultsModel(0, '', '', '', '', '', '', '');
    countrycode: string = '+1';

    private messageClientSource = new BehaviorSubject<number>(0);
    changeClient = this.messageClientSource.asObservable();

    private messageSelectedSource = new BehaviorSubject<ClientSearchResultsModel>(new ClientSearchResultsModel(0, '', '', '', '', '', '', ''));
    selectedClient = this.messageSelectedSource.asObservable();

    clients: ClientSearchResultsModel[] = [];
    client_family: ClientFamilyModel[] = []
    client_contact: ClientContactModel[] = []
    client_appts: ApptModel[] = []
    client_cash_reg: CashRegModel[] = []
    client_hold_check: CashRegModel[] = []
    client_ret_check: CashRegModel[] = []
    pages_client_cash_reg: number[] = []
    pages_client_hold_check: number[] = []
    pages_client_ret_check: number[] = []
    search: ClientSearchModel = new ClientSearchModel('', '', '', '', '', '', '', '',0,0, 1, TypeClientSearch.DETAIL);
    client: ClientModel = new ClientModel(0, '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',0, '', false, false, '', false,'',0,0,0);
    family: ClientFamilyModel = new ClientFamilyModel(0, '', '', '', 0, '', '', '', 0);
    contact: ClientContactModel = new ClientContactModel('', '', '', 0, 0, false);
    appt: ApptModel = new ApptModel(0, 0, 0, '', '', '', '', '', '', '', false);
    proc_list: ProcListModel[] = []
    selected_proc: ProcListModel = new ProcListModel(0, '', '');
    response: ResponseModel = new ResponseModel('', '', 0, '');
    briefhistorycategory1: BriefHistoryCategoryModel[] = []
    pettotaltransaction: PetTotalTransactionModel[] = []
    appt_detail : ApptDetailModel = new ApptDetailModel(0,'','','','',false,0,'','','','','','');
    hospitalized_patient_details: HospitalizedPatientDetailsModel[] = [];
    hospitalized_patient_details_nproc: HospitalizedPatientDetailsNProcModel[] = [];
    inc_lab_results_list: IncLabResultsListModel[] = [];
    inc_lab_results_list_single: IncLabResultsListSingleModel[] = [];
    client_info_recall: ClientInfoRecallModel[] = [];
    clinic_details: ClinicDetailsModel = new ClinicDetailsModel('', '', '', '', '', '','');
    procedure_list: ProcListModel[] = []
    clinic: ClinicModel= new ClinicModel(0,'','',0,'','','','','','','','',0,0,0,'',0,0,0,0,0,'',false,false,0,'','','','','',false,0,'','');
    annual_recall_phonelist: AnnualRecallPhonelist[] = []
    email_service: EmailServiceModel = new EmailServiceModel('','','','','')
    messages_list: MessagesModel[] = []
    client_email: ClientEmail[] = [];
    client_email_data: ClientEmail = new ClientEmail(0,0,'','')
    messagedata:{message_to: string,
                 message_body: string,
                 message_from: string,
                 message_date: string } = {message_to: '', message_body: '', message_from: '', message_date: ''}
    distinct_contacts: DistinctContactsModel[] = []
    signatureModel: SignatureModel = new SignatureModel(0,0,0,'',null,'2024-09-24','2024-09-24');
    client_files: ClientFilesModel[] = [];
    work_standalone_page:boolean = false
    work_pet_ribbon:boolean = true
    work_brief:boolean = true
    selectedClient_no:any = '';
    tmpbegindate=''
    tmpenddate=''
    tmpData = [];
    // userData: any = JSON.parse(localStorage['currentUser']);
    // clinicData: any = (JSON.parse(localStorage['clinic'])).find(x => x.clinic_no == this.userData.clinic_no);
    client_notes: ClientNoteModel[] = []
    client_note_type: ClientNoteTypeModel[] = []
    persons: PersonModel[] = [] 
    simple_client_list: {client_no: number, client_name: string}[] = [];

    //domain = environment.apiRoot  
    domain = 'https://ece8-103-152-4-18.ngrok-free.app/'

    


    constructor(
        private api: ApiService,
        private managerialService: ManagerialService,  
    ) {

    }


    changeClientVar(message: number) {
        this.messageClientSource.next(message)
        this.current_client_no = message;
    }

    selectedClientVar(message: ClientSearchResultsModel) {
        this.messageSelectedSource.next(message)
        this.selected_client = message;
        console.log(this.selected_client)
    }

    getSimpleClientList() {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getSimpleClientList`)
                .subscribe((res: any) => {
                    this.simple_client_list = res.data.map((element) => {
                        return {client_no: element.client_no, client_name: element.client_name};
                    });
                    console.log(this.simple_client_list);
                    resolve(1);
                });
        });
    }

    get userData(): any {
        return JSON.parse(localStorage.getItem('currentUser') || '{}');
    }
    
    get clinicData(): any {
        return (JSON.parse(localStorage['clinic'])).find(x => x.clinic_no == this.userData.clinic_no);
    }

    getClientsByParams() {
        let promise = new Promise((resolve, reject) => {
            if (this.search.page_number === 1)
                this.clients = [];

            let clinic_no = '0'; //not needed data use tenant instead
            let tenant_no = '';
            if (localStorage.currentUser && localStorage.token) {
                const currentUser: CurrentUserModel = JSON.parse(localStorage.currentUser);
                tenant_no = currentUser.tenant_no;
            }

            this.api.get<SearchResult>(`${this.baseUrl}/getClientsByParams?tenant_no=${tenant_no}&clinic_no=${clinic_no}&client_no=${this.sanitize(this.search.client_no)}&status=${this.sanitize(this.search.status)}&patient_no=${this.sanitize(this.search.patient_no)}&last_name=${this.sanitize(this.search.last_name)}&phone=${this.sanitize(this.search.phone)}&patient_name=${this.sanitize(this.search.patient_name)}&first_name=${this.sanitize(this.search.first_name)}&tag_no=${this.sanitize(this.search.tag_no)}&location_id=${this.search.location_id}&sublocation_id=${this.search.sublocation_id}&page_number=${this.search.page_number}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.clients.push(...res.data.map((element) => {
                            return new ClientSearchResultsModel(element.row_num, element.client_no, element.client_name, element.second_contact, element.phone_number, element.client_notes, element.active, element.last_invoice_date);
                        }));
                        resolve(1);
                    } else {
                        //this.clients = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    sanitize(text: string) {
        return text === null || text === undefined ? '' : text;
    }

    getClientById(client_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getClientById?client_no=${client_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.client = new ClientModel(client_no, res.data.last_name, res.data.first_name, res.data.middle_initial, res.data.salutation, res.data.home_phone, res.data.work_phone, res.data.work_phone_ext, res.data.address, res.data.city, res.data.state, res.data.zip, res.data.zip4, res.data.date_added, res.data.active, res.data.balance, res.data.client_code, res.data.last_visit, res.data.modified_date, res.data.contact_no, res.data.contact_ext, res.data.driver_license, res.data.social_security, res.data.credit_card_type, res.data.credit_card, res.data.expiration_date, res.data.source, res.data.county, res.data.year_to_date, res.data.family_instructions, res.data.allow_balance, res.data.allow_check, res.data.country, res.data.nonprofit, res.data.email_address, res.data.clinic_no,res.data.tenant_no,res.data.image_id);
                        this.changeClientVar(client_no);
                        resolve(this.client);
                    }
                });
        });
        return promise;
    }

    setupClient() {
        this.client.home_phone = this.client.home_phone.replace(/-/g, '');
        this.client.clinic_no = this.clinicData.clinic_no;
        this.client.tenant_no = this.managerialService.userData.tenant_no;

        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupClient`, this.client)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(res.data);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getClientFamily(client_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getClientFamily?client_no=${client_no}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.client_family = res.data.map((element) => {
                            return new ClientFamilyModel(element.family_client_no, element.last_name, element.first_name, element.relation, element.authority_id, element.home_phone, element.work_phone, element.work_phone_ext, element.client_no);
                        });
                        resolve(1);
                    } else {
                        this.client_family = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    setupClientFamily() {
        this.family.client_no = this.current_client_no;
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupClientFamily`, this.family)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    deleteClientFamily(family_client_no: number) {
        this.family.client_no = this.current_client_no;
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/deleteClientFamily?family_client_no=` + family_client_no)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getClientContact(client_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getClientContact?client_no=${client_no}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.client_contact = res.data.map((element) => {
                            return new ClientContactModel(element.contact_desc, element.contact_no, element.contact_ext, element.client_contact_id, element.client_no, element._default);
                        });
                        resolve(1);
                    } else {
                        this.client_contact = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    setupClientContact() {
        this.contact.client_no = this.current_client_no; 
        this.contact.contact_no = this.countrycode + this.contact.contact_no.replace(/-/g, '');

        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupClientContact`, this.contact)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    deleteClientContact(contact) {
        this.contact.client_no = this.current_client_no;
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/deleteClientContact`, contact)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getClientAppt(client_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getClientAppt?client_no=${client_no}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.client_appts = res.data.map((element) => {
                            return new ApptModel(element.client_no, element.appointment_id, element.sub_appt_id, element.pet_name, element.appointment_date, element.dropoff_time, element.doctor, element.doctor_name, element.appt_fulfill, element.appointment_note, element.dropoff);
                        });
                        resolve(1);
                    } else {
                        this.client_appts = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getClientCashReg(client_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getClientCashReg?client_no=${client_no}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.client_cash_reg = res.data.map((element) => {
                            return new CashRegModel(element.cashreg_sequence, element.client_no, element.method_of_pay, element.cashreg_date, element.amount_of_pay, element.payment_desc, element.check_card, element.cashier, element.cashreg_check, element.max_cashreg_date);
                        });

                        this.client.max_cashreg_date = this.client_cash_reg[0].max_cashreg_date;
                        this.client_hold_check = this.client_cash_reg.filter(t => t.cashreg_check !== 'X' && t.method_of_pay === H_CHECK);
                        this.client_ret_check = this.client_cash_reg.filter(t => t.method_of_pay === R_CHECK);

                        this.pages_client_cash_reg = []
                        for (let index = 0; index < Math.round(this.client_cash_reg.length / PAGE_SIZE); index++) {
                            this.pages_client_cash_reg.push(index + 1);
                        }

                        this.pages_client_hold_check = []
                        for (let index = 0; index < Math.round(this.client_hold_check.length / PAGE_SIZE); index++) {
                            this.pages_client_hold_check.push(index + 1);
                        }

                        this.pages_client_ret_check = []
                        for (let index = 0; index < Math.round(this.client_ret_check.length / PAGE_SIZE); index++) {
                            this.pages_client_ret_check.push(index + 1);
                        }
                        resolve(1);
                    } else {
                        this.client_cash_reg = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    checkClientPayInfo(client_no: string): Promise<string> {
        return new Promise((resolve, reject) => {
            this.api.get<string>(`${this.baseUrl}/CheckClientPayInfo?client_no=${client_no}`)
                .subscribe((res: string) => {
                    resolve(res);
                }, (error) => {
                    reject(error);
                });
        });
    }

    deleteClient(client_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/deleteClient?client_no=${client_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    searchClientsByParams(client_no: string, last_name: string, first_name: string) {

        let clientResult: ClientSearchResultsModel[] = [];
        let promise = new Promise((resolve, reject) => {
            if (this.search.page_number === 1)
                clientResult = [];

            this.api.get<SearchResult>(`${this.baseUrl}/getClientsByParams?client_no=${this.sanitize(client_no)}&tenant_no=${this.userData.tenant_no}&first_name=${this.sanitize(first_name)}&last_name=${this.sanitize(last_name)}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        clientResult.push(...res.data.map((element) => {
                            return new ClientSearchResultsModel(element.row_num, element.client_no, element.client_name, element.second_contact, element.phone_number, element.client_notes, element.active, element.last_invoice_date);
                        }));
                        resolve(clientResult);
                    } else {
                        clientResult = [];
                        resolve(clientResult);
                    }
                });
        });
        return promise;
    }

    getProcCodeList(clinic: number, procedure_no: number, procedure_code: string, procedure_desc: string, PageNumber: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getProcCodeList?clinic=${clinic}&procedure_no=${procedure_no}&procedure_code=${procedure_code}&procedure_desc=${procedure_desc}&PageNumber=${PageNumber}`)
                .subscribe((res: any) => {
                    //console.log(res);
                    if (res && res.results > 0) {
                        this.proc_list.push(...res.data.map((element) => {
                            return new ProcListModel(element.procedure_no, element.procedure_code, element.procedure_desc);
                        }));
                        resolve(1);
                    } else {
                        this.proc_list = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    checkResponseHistory(pet_no: number, link_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/CheckResponseHistory?pet_no=${pet_no}&link_no=${link_no}`)
                .subscribe((res: any) => {
                    //console.log(res);
                    if (res && res.results > 0) {

                        this.response = new ResponseModel(res.data[0].response1, res.data[0].response2, res.data[0].history_sequence, res.data[0].done_date);

                        resolve(1);
                    } else {
                        this.response = new ResponseModel('', '', 0, '');
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    updateResponse(history_sequence: number, pet_no: number, response1: string, response2: string, proc_code: string, strDoneDate: string, username: string) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/updateResponse?history_sequence=${history_sequence}&pet_no=${pet_no}&response1=${response1}&response2=${response2}&proc_code=${proc_code}&strDoneDate=${strDoneDate}&username=${username}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getBriefHistoryCateg(clinic: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getBriefHistoryCateg?clinic=${clinic}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        //console.log(res)
                        this.briefhistorycategory1 = res.data.map((element) => {
                            return new BriefHistoryCategoryModel(element.brief_history_category);
                        });
                        resolve(1);
                    } else {
                        this.briefhistorycategory1 = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getPetTotalTransaction(pet_no_from: number, pet_no_to: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetPetTotalTransaction?pet_no_from=${pet_no_from}&pet_no_to=${pet_no_to}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.pettotaltransaction = res.data.map((element) => {
                            return new PetTotalTransactionModel(element.pet_no, element.totaltransaction);
                        });
                        resolve(1);
                    } else {
                        this.pettotaltransaction = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    mergePetPatient(pet_no_from: number, pet_no_to: number, client_no_to: number, client_no_for: number, strPetFrom: string, strPetTo: string, strUserName: string) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/MergePetPatient?pet_no_from=${pet_no_from}&pet_no_to=${pet_no_to}&client_no_to=${client_no_to}&client_no_for=${client_no_for}&strPetFrom=${strPetFrom}&strPetTo=${strPetTo}&strUserName=${strUserName}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }
    //MergePetPatient(int pet_no_from, int pet_no_to, int client_no_to, int client_no_for, string strPetFrom, string strPetTo, string strUserName)

    GetApptDetailByApptID(appointment_id: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetApptDetailByApptID?appointment_id=${appointment_id}`)
                .subscribe((res: any) => { 
                    if (res && res.results > 0) { 
                        this.appt_detail = new ApptDetailModel(res.data.client_no, res.data.last_name, res.data.first_name	, res.data.doctor, res.data.dropoff_time, res.data.dropoff, res.data.pet_no, res.data.appt_proc_name, res.data.appointment_note, res.data.code1, res.data.code2, res.data.code3, res.data.appt_fulfill);
                        
                        resolve(res);
                    } else {
                        this.appt_detail = new ApptDetailModel(0,'','','','',false,0,'','','','','','');
                        resolve(res);
                    } 
                });
        });
        return promise;
    }
    
    GetHospitalizedPetWProc(tag_nos) {
        const requestBody = {
            tag_nos: tag_nos, 
        };

        let promise = new Promise((resolve, reject) => {
            this.api.post<SearchResult>(`${this.baseUrl}/GetHospitalizedPetWProc`, requestBody)
                .subscribe((res: any) => { 
                    if (res && res.results > 0) { 
                        this.hospitalized_patient_details = res.data.map((element) => {
                            return new HospitalizedPatientDetailsModel(element.client_no,element.last_name,element.first_name,element.tag_no,
                                element.pet_no,element.pet_name,element.sex,element.weight,element.specie_name,element.breed_name,element.color_name
                                ,element.req_date,element.link_no,element.link_type,element.status,element.unit,element.cost);
                        });

                        resolve(1);
                    } else {
                        this.hospitalized_patient_details = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getHospitalizedPetNProc(tag_nos) {
        const requestBody = {
            tag_nos: tag_nos, 
        }; 

        let promise = new Promise((resolve, reject) => {
            this.api.post<SearchResult>(`${this.baseUrl}/getHospitalizedPetNProc`,requestBody)
                .subscribe((res: any) => { 
                    if (res && res.results > 0) { 
                        this.hospitalized_patient_details_nproc = res.data.map((element) => {
                            return new HospitalizedPatientDetailsNProcModel(element.client_no,element.last_name,element.first_name,element.tag_no,
                                element.pet_no,element.pet_name,element.sex,element.weight,element.specie_name,element.breed_name,element.color_name);
                        });

                        resolve(1);
                    } else {
                        this.hospitalized_patient_details_nproc = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    GetIncLabReport(clinic_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getIncLabReport?clinic_no=${clinic_no}`)
                .subscribe((res: any) => { 
                    if (res && res.results > 0) { 
                        this.inc_lab_results_list = res.data.map((element) => {
                            return new IncLabResultsListModel(element.last_name,element.first_name,element.pet_no,element.pet_name,
                                element.code_name,element.done_date,element.employee_initial); 
                        });

                        resolve(1);
                    } else {
                        this.inc_lab_results_list = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getIncLabReportSingle(pet_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getIncLabReportSingle?pet_no=${pet_no}`)
                .subscribe((res: any) => { 
                    if (res && res.results > 0) { 
                        this.inc_lab_results_list_single = res.data.map((element) => {
                            return new IncLabResultsListSingleModel(element.pet_name,element.last_name,element.link_no,element.link_type,
                                element.done_date,element.employee_initial,element.procedure_code,element.procedure_desc,element.history_sequence); 
                        });					 
                        resolve(1);
                    } else {
                        this.inc_lab_results_list_single = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }
 

    DeleteIncLabTran(history_sequence: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/DeleteIncLabTran?history_sequence=${history_sequence}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    } 

    getClientInfoForRecall(start_date: string,end_date: string,brief_hist_category: string) {
        let promise = new Promise((resolve, reject) => {
            this.api.post<SearchResult>(`${this.baseUrl}/getClientInfoForRecall?start_date=${start_date}&end_date=${end_date}&brief_hist_category=${brief_hist_category}`)
                .subscribe((res: any) => { 
                    if (res && res.results > 0) { 
                        this.client_info_recall = res.data.map((element) => {
                            return new ClientInfoRecallModel(element.client_no,	element.pet_name, element.last_name, element.first_name, element.address, element.city, element.state, element.zip, element.zip4, element.brief_hist_code, element.brief_hist_date, element.pet_code, element.brief_hist_category); 
                        });
                        resolve(1);
                    } else {
                        this.client_info_recall = [];
                        resolve(0);
                    } 
                });
        });
        return promise;
    }

    GetClinicDetailsByNo(clinic_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetClinicDetailsByNo?clinic_no=${clinic_no}`)
                .subscribe((res: any) => { 
                    if (res && res.results > 0) { 
                        this.clinic_details = new ClinicDetailsModel(res.data.clinic_name, res.data.clinic_address, res.data.city	, res.data.state, res.data.clinic_zip,res.data.clinic_phone,res.data.invoice_message);
                        
                        resolve(res); 
                    } else {
                        this.clinic_details = new ClinicDetailsModel('', '', '', '', '', '', '');
                        resolve(res);
                    } 
                });
        });
        return promise;
    }

    GetProcedureList() {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetProcedureList`)
                .subscribe((res: any) => { 
                    if (res && res.results > 0) { 
                        this.procedure_list = res.data.map((element) => {
                            return new ProcListModel(element.procedure_no,	element.procedure_code, element.procedure_desc); 
                        });
                        resolve(1);
                    } else {
                        this.procedure_list = [];
                        resolve(0);
                    } 
                });  
        });
        return promise;
    }

    SetupClinic() {  
        console.log(this.clinic)
        this.clinic.doctor_date = ''
        this.clinic.admin_password = ''
        this.clinic.corp_password = ''
        this.clinic.corp_password = ''
        this.clinic.inv_proc_password = '' 
        this.clinic.manage_password = '' 
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupClinic`, this.clinic)
                .subscribe((res: any) => {
                    console.log(res)
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    } 

    SetupLabData( lngPetNo:number, strAccNo:string, strLabDate:string, txtNote:string, lblInit:string, txtLabDate:string){   
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupLabData?lngPetNo=${lngPetNo}&strAccNo=${strAccNo}&strLabDate=${strLabDate}&txtNote=${txtNote}&lblInit=${lblInit}&txtLabDate=${txtLabDate}`)
                .subscribe((res: any) => {
                    console.log(res)
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    } 

    GetAnnualRecallPhoneList(dteBeginDate: string,dteEndDate: string) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetAnnualRecallPhoneList?dteBeginDate=${dteBeginDate}&dteEndDate=${dteEndDate}`)
                .subscribe((res: any) => { 
                    if (res && res.results > 0) { 
                        this.annual_recall_phonelist = res.data.map((element) => {
                            return new AnnualRecallPhonelist(element.client_no,element.pet_name,element.last_name,element.first_name,element.address,element.city,element.state,element.zip,element.zip4,element.brief_hist_code,element.brief_hist_date,element.pet_code,element.client_code,element.home_phone);
                        });// client_no	pet_name	last_name	first_name	address	city	state	zip	zip4	brief_hist_code	brief_hist_date	pet_code	client_code	home_phone
                        resolve(res); 
                    } else {
                        this.annual_recall_phonelist = [];
                        resolve(res);
                    } 
                });
        });
        return promise;
    } 
 
    SendEmail() {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SendEmail`, this.email_service)
                .subscribe((res: any) => {
                    console.log(res)
                    if (res && res.data) {
                        resolve(res);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    } 

    formatPhoneNumber(phoneNumber: string, countryCode: string) {
        if (!phoneNumber) return '';
        
        // Check if the number is already in international format
        const internationalFormat = /^\+\d+$/;
        if (internationalFormat.test(phoneNumber)) {
            return phoneNumber;
        }
        
        // Remove non-numeric characters
        const cleanedNumber = phoneNumber.replace(/[^\d]/g, '');
    
        // Add country code prefix
        const formattedNumber = '+' + countryCode + cleanedNumber;
    
        return formattedNumber;
    }
    

    SendMessage(toNumber: string,messageBody: string,mediaUrl: string, pet_nos: number[]) {
        const entoNumber = this.clinicData.country_code + encodeURIComponent(toNumber);
        const enfromNumber = this.clinicData.country_code + encodeURIComponent(this.clinicData.web_phone); 
 
        const requestBody = {
            fromNumber: enfromNumber,
            toNumber: entoNumber, 
            messageBody: messageBody, 
            mediaUrl: mediaUrl, 
            domain: this.domain, 
            pet_no: pet_nos,  
            clinic_no: this.clinicData.clinic_no
          };

          console.log(requestBody)
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SendMessage`, requestBody)
                .subscribe((res: any) => {  
                    if (res && res.data) {
                        resolve(res);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise; 
    } 

    scheduledSMS(toPhoneNumber: string,message: string,scheduleAt: string, pet_nos: number[]) {
        const entoNumber = encodeURIComponent(toPhoneNumber);
        const enfromNumber = encodeURIComponent(this.clinicData.web_phone);
 
        const requestBody = {
            fromNumber: this.clinicData.web_phone,
            toNumber: toPhoneNumber, 
            messageBody: message, 
            mediaUrl: '', 
            domain: this.domain, 
            pet_no: pet_nos, 
            clinic_no: this.clinicData.clinic_no
          };

        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/scheduledSMS?scheduleAt=${scheduleAt}`, requestBody)
                .subscribe((res: any) => {
                    console.log(res)
                    if (res && res.data) {
                        resolve(res);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    GetMessages() {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetMessages`)
                .subscribe((res: any) => { 
                    if (res && res.results > 0) { 
                        this.messages_list = res.data.map((element) => {
                            return new MessagesModel(element.SID,element.mFrom,element.mTo,element.mBody,element.mStatus,element.mDateCreated,element.first_name,element.client_no);
                        });
                        resolve(res); 
                    } else {
                        this.messages_list = [];
                        resolve(res);
                    } 
                });
        });
        return promise;
    }  

    GetClientEmail(client_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetClientEmail?client_no=${client_no}`)
                .subscribe((res: any) => { 
                    if (res && res.results > 0) { 
                        this.client_email = res.data.map((element) => {
                            return new ClientEmail(element.client_email_id,element.client_no,element.email_desc,element.email_address);
                        });
                        resolve(this.client_email); 
                    } else {
                        this.client_email = [];
                        resolve(this.client_email);
                    } 
                });
        });
        return promise;
    } 

    SetupClientEmail(actionType) {
        console.log(this.client_email_data)
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupClientEmail?actionType=${actionType}`, this.client_email_data)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    } 

    
    GetDistinctContacts() {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetDistinctContacts`)
                .subscribe((res: any) => { 
                    if (res && res.results > 0) { 
                        this.distinct_contacts = res.data.map((element) => {
                            return new DistinctContactsModel(element.mTo,element.mDateCreated,element.first_name,element.client_no);
                        });
                        resolve(1); 
                    } else {
                        this.distinct_contacts = [];
                        resolve(0);
                    } 
                });
        });
        return promise;
    } 
    
    GetClientNote(client_no: number,note_type: number,startDate: string,endDate: string) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetClientNote?client_no=${client_no}&note_type=${note_type}&startDate=${startDate}&endDate=${endDate}`)
                .subscribe((res: any) => { 
                    if (res && res.results > 0) { 
                        this.client_notes = res.data.map((element) => {
                            return new ClientNoteModel(element.note_sequence,element.client_no,element.note_type,element.note_text,element.note_date);
                        });
                        resolve(1); 
                    } else {
                        this.client_notes = [];
                        resolve(0);
                    } 
                });
        });
        return promise;
    } 

    GetClientNoteType() {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetClientNoteType`)
                .subscribe((res: any) => { 
                    if (res && res.results > 0) { 
                        this.client_note_type = res.data.map((element) => {
                            return new ClientNoteTypeModel(element.note_type,element.type_desc);
                        });
                        resolve(1); 
                    } else {
                        this.client_note_type = [];
                        resolve(0);
                    } 
                });
        });
        return promise;
    } 
     
    setupClientNote(action_type:number,note_sequence:number, client_no:number, note_type:number, note_text:string) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupClientNote?action_type=${action_type}&note_sequence=${note_sequence}&client_no=${client_no}&note_type=${note_type}&note_text=${note_text}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }  

    releasedEstimate:{estimate_def_sequence:number, client_no:number, pet_no:number, released_date:string, client_signature:number, attending_id:number, attending_signature:number} = {estimate_def_sequence:0, client_no:0, pet_no:0, released_date:'', client_signature:0, attending_id:0, attending_signature:0};
    setupReleasedEstimate(){
        let promise = new Promise((resolve, reject) => {
            this.api.post(`pet/SetupReleasedEstimate?estimate_def_sequence=${this.releasedEstimate.estimate_def_sequence}&client_no=${this.releasedEstimate.client_no}&pet_no=${this.releasedEstimate.pet_no}&released_date=${this.releasedEstimate.released_date}&client_signature=${this.releasedEstimate.client_signature}&attending_id=${this.releasedEstimate.attending_id}&attending_signature=${this.releasedEstimate.attending_signature}`)
                .subscribe((res: any) => {
                    if (res && res.data) { 
                        resolve(res.data); 
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    setupSignatureSolo(Id: number, UserId: number, DocumentId: number, SignatureData: string, SignatureDataBinary: any, CreatedAt: string, UpdatedAt: string) {
        let signaturedata: SignatureModel = new SignatureModel(
            Id, UserId, DocumentId, SignatureData, SignatureDataBinary, CreatedAt, UpdatedAt
        ); 

        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupSignatures`,signaturedata)
                .subscribe((res: any) => {
                    if (res && res.data) {  
                        resolve(res.data);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }  

    //getClientFiles?client_no=44936
    getClientFiles(client_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getClientFiles?client_no=${client_no}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.client_files = res.data.map((element) => {
                            return new ClientFilesModel(element.FileId, element.client_no, element.id, element.FilePath, element.FileType, element.DateAdded, element.CreatedBy, element.username, element.image_bidata);
                        });
                        resolve(1);
                    } else {
                        this.client_files = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    //SetupClientFile(int id, int client_no, string filePath, string fileType, int createdBy)
    setupClientFile(id:number, client_no:number, filePath:string, fileType:string, createdBy:number) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupClientFile?id=${id}&client_no=${client_no}&filePath=${filePath}&fileType=${fileType}&createdBy=${createdBy}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    //#region Signature

    pageFrom:string = ''

    openSignatureModal(from:string) {
        $('#modalSignature').modal('show');
        this.pageFrom = from;
    }

    client_signature:number = 0

    setupSignature() {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupSignatures`,this.signatureModel)
                .subscribe((res: any) => {
                    if (res && res.data) { 
                        this.client_signature = res.data 
                        this.continueAfterSignature(this.client_signature)
                        $('#modalSignature').modal('hide');
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }
    
    setupSignature2() {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupSignatures`,this.signatureModel)
                .subscribe((res: any) => {
                    if (res && res.data) {  
                        resolve(res.data );
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }  

    continueAfterSignature(signature_id:number) { 
        if(this.pageFrom == 'estimate') {
            this.releasedEstimate.attending_signature = signature_id; 
            this.setupReleasedEstimate().then((res) => { 
                this.print_file(
                    'FPC_ApprovedEstimate',
                    'Estimate',
                    '&id='+ res + '&clinic_no=' + this.userData.clinic_no
                ); 
            });
        }
        else if(this.pageFrom == 'invoice'){
            this.triggerPrintInvoice()
            console.log('invoice this this')
        }
        else if(this.pageFrom == 'releaseForms'){
            this.client_signature = signature_id;
            this.triggerPrintReleaseForm()
        }
    }

    PRF_name:string = ''
    PRF_id:number = 0
    PRF_pet_no:number = 0 
    triggerPrintReleaseForm() { 
            let clinic_no = this.userData.clinic_no; 
            let $string = `admin` + "U*63r" + 'FPC_ReleasedForms' + "R0d&3" + 'pdf' + "R3nd%" + '' + "Fr3n6" + this.PRF_name + "T1*73";
            let $result = encode_utf8($string);
            $result = encode_base64($result); 
            let $strfilter =  `&clinic_no=${clinic_no}&id=${this.PRF_id}&pet_no=${this.PRF_pet_no}&sign_id=${this.client_signature}`;
            let url = `https://ssrs.itimpact.com/fpc_ssrs/default.aspx?token=${$result}${$strfilter}`; 
            window.open(url, '_self', 'visible=none'); 
    }

    private printInvoiceSubject = new Subject<void>(); 
    printInvoiceObservable = this.printInvoiceSubject.asObservable(); 
    triggerPrintInvoice() {
        console.log('shared service triggerPrintInvoice');
        this.printInvoiceSubject.next();
    }

    print_file(name:string,filename:string,filter:string) { 
        let $string = `admin` + "U*63r" + name + "R0d&3" + 'pdf' + "R3nd%" + '' + "Fr3n6" + filename + "T1*73";
        let $result = encode_utf8($string);
        $result = encode_base64($result); 
        let $strfilter = filter; 
        let url = `https://ssrs.itimpact.com/fpc_ssrs/default.aspx?token=${$result}${$strfilter}`; 
        window.open(url, '_self', 'visible=none');
    }
  

    //#endregion
    
    // setupPerson(actionType) {
    //     console.log(this.person) 
    //     this.person.client_no = this.current_client_no;
    //     let promise = new Promise((resolve, reject) => {
    //         this.api.post(`${this.baseUrl}/SetupPerson?action_type=${actionType}`, this.person)
    //             .subscribe((res: any) => {
    //                 if (res && res.data) {
    //                     resolve(1);
    //                 } else {
    //                     resolve(0);
    //                 }
    //             });
    //     });
    //     return promise;
    // } 


}